module.exports = __webpack_public_path__ + "img/sales.49e1131.png";